import Request from "luch-request";
import { showToast } from "./utils.js";
import { appSystemInfo, baseUrl } from "@/app.config.js";
import storage from "./storage.js";
import { useUserStore } from "@/stores/user.js";
import i18n from '@/locale/index.js'
import { getBackendLanguageKey } from './utils.js'


const http = new Request();

http.setConfig((config) => {
	config.baseURL = baseUrl;
	return config;
});


// 并发同 key 请求：复用同一个 Promise，避免重复发包
const pendingRequests = new Map();

function generateReqKey(config) {
	const { url, method, data, params } = config;
	return `${method}|${url}|${JSON.stringify(data)}|${JSON.stringify(params)}`;
}

const originalRequest = http.request.bind(http);
http.request = function(config = {}) {
	if (config.noDebounce) {
		return originalRequest(config);
	}
	const key = generateReqKey(config);
	if (pendingRequests.has(key)) {
		return pendingRequests.get(key);
	}
	const promise = originalRequest(config).finally(() => {
		pendingRequests.delete(key);
	});
	pendingRequests.set(key, promise);
	return promise;
};

http.interceptors.request.use(async (config) => {
	const userStore = useUserStore();
	const token = userStore.token;

	config.header['Authorization'] = token || '';
	config.header['version'] = appSystemInfo.version;
	config.header['device'] = appSystemInfo.platform;
	config.header['channel'] = appSystemInfo.channel;
	config.header['lang'] = getBackendLanguageKey(storage.get('language') || uni.getLocale());

	return config;
}, config => {
	return Promise.reject(config);
});

http.interceptors.response.use((response) => {
	uni.hideLoading();
	const userStore = useUserStore();
	switch (response.data.code) {
		case 'E_000': // 成功
			return response.data.data;
		case 'E_002': // token 异常
			userStore.onRemoveToken();
			showToast(i18n.global.t('loginShowTitle')).then(() => {
				uni.navigateTo({ url: '/pages/Auth/Index' });
			});
			return Promise.reject(response);
		case 'E_004': // 登录失效
		case 'E_011': // 未登录
		case 'E_010': // 未绑定手机号
		case 'E_025': // 未绑定手机号
			userStore.onLoginOut();
			showToast(response.data.message || i18n.global.t('hotTry'));
			return Promise.reject(response);
		case 'E_023': // 未设置支付密码
			showToast(i18n.global.t('setPayPassWord')).then(() => {
				uni.navigateTo({ url: '/pages/User/ChangePayPassword' });
			});
			return Promise.reject(response);
		default:
			showToast(response.data.message || i18n.global.t('hotTry'));
			return Promise.reject(response);
	}
}, (error) => {
	uni.hideLoading();
	const userStore = useUserStore();
	// 避免重复处理 token 过期
	if (error.data?.code === 'E_002') {
		userStore.onRemoveToken();
		uni.navigateTo({ url: '/pages/Auth/Index' });
		return;
	}

	if (error.statusCode) {
		showToast(error.statusCode, {
			// #ifdef MP-WEIXIN
			icon: 'error'
			// #endif
		});
	} else if (error.errMsg === "request:fail timeout") {
		showToast(i18n.global.t('outTime'), {
			// #ifdef MP-WEIXIN
			icon: 'error'
			// #endif
		});
	} else if (error.errMsg === "request:fail ") {
		showToast(i18n.global.t('hotTry'));
	}

	return Promise.reject(error);
});

export default http;
